import { BaseValidationComponent } from './base';
export default class TpkValidationSelect extends BaseValidationComponent {}